import VueRouter from 'vue-router'
import router from "./core/vue-router/vue-router-auth";
import registerSentry from "@/core/utils/helpers/registerSentry";

require('./global');

window.Vue = require('vue');

utils.registerGlobalComponents(Vue);

/**
 * Local component registration
 */
Vue.component('users-auth-register-component', require('./components/users/auth/RegistrationComponent').default);
Vue.component('users-auth-login-component', require('./components/users/auth/LoginComponent').default);
Vue.component('users-verify-phone-component', require('./components/users/auth/UsersVerifyPhoneComponent').default);
Vue.component('users-verify-phone-whatsapp-component', require('./components/users/auth/UsersVerifyPhoneWhatsappComponent.vue').default);
Vue.component('modal-verify-email-component', require('./components/users/auth/ModalVerifyEmailComponent').default);
Vue.component('registration-features-component', require('./components/auth/registrationFeaturesComponent.vue').default);
Vue.component('registration-hero-page-component', require('./components/auth/registrationHeroPageComponent.vue').default);
Vue.component('login-accounts-information-component', require('./components/auth/loginAccountsInformationComponent.vue').default);
Vue.component('guest-xpate-processing-component', require('./components/guests/GuestXpateProcessingComponent.vue').default);

Vue.use(VueRouter);

if (process.env.MIX_VUE_DEV_TOOLS) {
    Vue.config.devtools = true;
}

registerSentry(router);

const app = new Vue({
    el: '#app',
    store: $store,
    router,
    methods: {
        setTranslate: async () => {
            $store.commit('setTranslate', translate);
            $store.commit('setRegionData', regionData);
            $store.commit('setSettings', settings);
            $store.commit('setLocale', locale);
            $store.commit('setCountryName', countryName);
            $store.commit('setCountrySlug', countrySlug);
        }
    }
});

app.setTranslate();

window.$store = $store;
